export const decodeJwt = (token: string) => {
	const payload = token.split(".")[1];
	const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
	return JSON.parse(json);
};

export const isJwtTokenExpired = (token: string, expiryBufferMs: number = 5_000): boolean => {
	try {
		const payload = decodeJwt(token);
		if (!payload.exp) return false; // no exp claim, treat as non-expiring
		return payload.exp * 1000 - expiryBufferMs < Date.now();
	} catch {
		return true;
	}
};
